export default "__VITE_PUBLIC_ASSET__2156dd87__"